import { useAuth0 } from "@auth0/auth0-react";
import { Box, Grid2, Paper, Typography } from "@mui/material";
import HeaderBar from "../Shared/HeaderBar/HeaderBar";
import NavigationBar from "../Shared/NavigationBar/NavigationBar.js"

export default function ProfilePage() {
    const { user } = useAuth0();
    return (
        <>
            <HeaderBar></HeaderBar>
            <Grid2 container={true} paddingTop={'1em'} justifyContent={'center'} alignItems={'center'} direction={'row'} wrap={"wrap"} spacing={1} id={"ProfilePageGrid"}>
                <Paper
                    elevation={3}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 3,
                        padding: 2,
                        maxWidth: 400,
                        margin: "auto",
                    }}
                >
                    <Box component="img" src={user.picture} alt={user.name} sx={{width: "5rem"}} />
                    <Typography>{user.email}</Typography>
                </Paper>
            </Grid2>
            <NavigationBar></NavigationBar>
        </>
    );
}
